import { render, staticRenderFns } from "./SurveyNumber.vue?vue&type=template&id=5b758738&"
import script from "./SurveyNumber.vue?vue&type=script&lang=js&"
export * from "./SurveyNumber.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports